(function() {
  function newSearchOrder() {
    document.querySelector('#searchParameter').onchange = function() {
      if (this.value === 'Confirmation Number') {
        $('.ph-search__nonconfirmation').addClass('hidden ph-disabledbutton ');
        $('.ph-confirmationnumber').removeClass('hidden ph-disabledbutton');
        $('.ph-search__nonconfirmation input').val('');
        $('.ph-confirmationnumber input').focus();
      } else if (this.value === 'Ship-to Number') {
        $('.ph-confirmationnumber,.ph-search__materialnumber, .ph-search__purchaseordernumber').addClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber input,.ph-search__materialnumber input, .ph-search__purchaseordernumber input').val('');
        $('.ph-search__nonconfirmation,.ph-search__accountnumber').removeClass('hidden ph-disabledbutton');
        $('.ph-search__nonconfirmation .ph-search__accountnumber input').focus();
      } else if (this.value === 'Material Number') {
        $('.ph-confirmationnumber,.ph-search__accountnumber, .ph-search__purchaseordernumber').addClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber input,.ph-search__accountnumber input, .ph-search__purchaseordernumber input').val('');
        $('.ph-search__nonconfirmation,.ph-search__materialnumber').removeClass('hidden ph-disabledbutton');
        $('.ph-search__nonconfirmation .ph-search__materialnumber input').focus();
      } else if (this.value === 'PO number') {
        $('.ph-confirmationnumber,.ph-search__accountnumber, .ph-search__materialnumber').addClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber input,.ph-search__accountnumber input, .ph-search__materialnumber input').val('');
        $('.ph-search__nonconfirmation,.ph-search__purchaseordernumber').removeClass('hidden ph-disabledbutton');
        $('.ph-search__nonconfirmation .ph-search__purchaseordernumber input').focus();
      } else {
        $('.ph-search__nonconfirmation').removeClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber').addClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber input').val('');
      }
    };
  }

  function newAnonymousSearchOrder() {
    document.querySelector('#anonymoussearchParameter').onchange = function() {
      if (this.value === 'Confirmation Number Postal code') {
        $('.ph-search__nonconfirmation').addClass('hidden ph-disabledbutton');
        $('.ph-search__nonconfirmation input').val('');
        $('.ph-confirmationnumber').removeClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber input#confirmationNumber').focus();
      } else if (this.value === 'Sold-to Number PO number') {
        $('.ph-confirmationnumber').addClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber input').val('');
        $('.ph-search__nonconfirmation').removeClass('hidden ph-disabledbutton');
        $('.ph-search__nonconfirmation input#accountNumber').focus();
        ACC.orderSearch.datePickerInit($('#fromDate'));
        ACC.orderSearch.datePickerInit($('#toDate'));
        $('#anonymousSearchOrderForm .anonymous_holder.setTwoHolder').removeClass('disabled');
        $('#anonymousSearchOrderForm .anonymous_holder.setTwoHolder input').attr('disabled', false);
        $('.ph-searchorder-setTwoHolder').removeClass('disabled');
        $('.ph-searchorder-setOneHolder').removeClass('enabled');
      } else {
        $('.ph-search__nonconfirmation').removeClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber').addClass('hidden ph-disabledbutton');
        $('.ph-confirmationnumber input').val('');
      }
    };
  }

  window.addEventListener('DOMContentLoaded', function() {
    if (document.querySelectorAll('#searchParameter').length > 0) {
      newSearchOrder();
      $('#searchParameter option').each(function() {
        if ($(this).prop('selected')) {
          if (this.value === 'Confirmation Number') {
            $('.ph-search__nonconfirmation').addClass('hidden ph-disabledbutton');
            $('.ph-confirmationnumber').removeClass('hidden ph-disabledbutton');
          } else if (this.value === 'Ship-to Number') {
            $('.ph-confirmationnumber,.ph-search__materialnumber, .ph-search__purchaseordernumber').addClass('hidden ph-disabledbutton');
            $('.ph-search__nonconfirmation,.ph-search__accountnumber').removeClass('hidden ph-disabledbutton');
          } else if (this.value === 'Material Number') {
            $('.ph-confirmationnumber,.ph-search__accountnumber, .ph-search__purchaseordernumber').addClass('hidden ph-disabledbutton');
            $('.ph-search__nonconfirmation,.ph-search__materialnumber').removeClass('hidden ph-disabledbutton');
          } else if (this.value === 'PO number') {
            $('.ph-confirmationnumber,.ph-search__accountnumber, .ph-search__materialnumber').addClass('hidden ph-disabledbutton');
            $('.ph-search__nonconfirmation,.ph-search__purchaseordernumber').removeClass('hidden ph-disabledbutton');
          } else {
            $('.ph-search__nonconfirmation').removeClass('hidden ph-disabledbutton');
            $('.ph-confirmationnumber').addClass('hidden ph-disabledbutton');
          }
        }
      });
      $('.ph-selectsearch select').focus(function() {
        $(this).siblings('label').addClass('ph-selectlabel');
      });

      $('.ph-selectsearch select').focusout(function() {
        $(this).siblings('label').removeClass('ph-selectlabel');
      });
    }
  });

  window.addEventListener('DOMContentLoaded', function() {
    if (document.querySelectorAll('#anonymoussearchParameter').length > 0) {
      newAnonymousSearchOrder();
      $('#anonymoussearchParameter option').each(function() {
        if ($(this).prop('selected')) {
          if (this.value === 'Confirmation Number Postal code') {
            $('.ph-search__nonconfirmation').addClass('hidden ph-disabledbutton');
            $('.ph-confirmationnumber').removeClass('hidden ph-disabledbutton');
          } else if (this.value === 'Sold-to Number PO number') {
            $('.ph-confirmationnumber').addClass('hidden ph-disabledbutton');
            $('.ph-search__nonconfirmation').removeClass('hidden ph-disabledbutton');
          } else {
            $('.ph-search__nonconfirmation').removeClass('hidden ph-disabledbutton');
            $('.ph-confirmationnumber').addClass('hidden ph-disabledbutton');
          }
        }
      });
      $('.ph-selectsearch select').focus(function() {
        $(this).siblings('label').addClass('ph-selectlabel');
      });

      $('.ph-selectsearch select').focusout(function() {
        $(this).siblings('label').removeClass('ph-selectlabel');
      });
    }
  });
})();
$(window).on('load', function() {
  if ($.trim($('.prefillConfirmationNumber').text()) !== '') {
    $('.ph-confirmationnumber #ph-confirmationNumber').val($.trim($('.prefillConfirmationNumber').text()));
    $('#onestoreSearchSubmit').trigger('click');
  }
});
